"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextTransformSchema = exports.TextTransformReplaceSchema = exports.TextTransformBarSchema = void 0;
const zod_1 = require("zod");
exports.TextTransformBarSchema = zod_1.z.object({
    type: zod_1.z.literal('bar'),
    from: zod_1.z.number(),
    to: zod_1.z.number(),
    width: zod_1.z.number().optional(),
});
exports.TextTransformReplaceSchema = zod_1.z.object({
    type: zod_1.z.literal('replace'),
    start: zod_1.z.number(),
    length: zod_1.z.number(),
    value: zod_1.z.string(),
});
exports.TextTransformSchema = zod_1.z.discriminatedUnion('type', [
    exports.TextTransformBarSchema,
    exports.TextTransformReplaceSchema,
]);
//# sourceMappingURL=TextTransform.js.map